<template>
  <div id="collegeDetail" class="margin-top">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>生涯规划</el-breadcrumb-item>
      <el-breadcrumb-item>找大学</el-breadcrumb-item>
      <el-breadcrumb-item :to="{path:'/stu/college'}" class="cursorSz">
        院校信息库
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div class="college_info  w-100 margin-top">
      <div v-show="univerSityDetail!==''&&!loadingDetail" class="g-wrapper">

        <div class="left">
          <div class="logo">
            <img v-lazy="univerSityDetail.logo" :key="univerSityDetail.logo" src="" alt="">
          </div>
          <div class="info">
            <h2>{{ univerSityDetail.name }}</h2>
            <p class="tags">
              <span v-for="item in  univerSityFeature" :key="item">{{ item }}</span>
            </p>
            <p class="txt">
              <span>办学类型：{{ univerSityDetail.buildTypeName }}</span>
              <span>学历层次：{{ univerSityDetail.levelName }}</span>
              <span>院校隶属：{{ univerSityDetail.belongTo }}</span>
              <span>建校时间：{{ univerSityDetail.foundingYear }}年</span>
              <el-button size="small" v-show="getUniverSityFav===0"
                         @click="collectionContent">
                <span class="text-l-size  el-icon-star-off vertical-middle"></span>
                <span class="vertical-middle">收藏</span>
              </el-button>
              <el-button size="small" v-show="getUniverSityFav===1"
                         type="primary" @click="cancelCollection">
                                <span class="text-l-size vertical-middle el-icon-star-off">
                                </span><span class="vertical-middle">取消收藏</span>
              </el-button>

            </p>
          </div>
        </div>

      </div>
      <loading :show="loadingDetail"></loading>
    </div>
    <div class="college_tab">
      <div class="g-wrapper flex">
        <ul class="tab " :class="gudFlag?'gud':''">
          <li v-for="item in getLeftDirectoryList" :key="item.id">
            <a href="javaScript:;" :class="getDirectoryName===item.name?'directoryActive':''"
               class="router-link-exact-active  " @click="selectDirectory(item.name)">{{ item.name }}</a>
          </li>
        </ul>
        <div class="content w-100" :class="gudFlag?'gud':''">
          <div class="overview">
            <div class="title">{{ univerSityName + getDirectoryName }}</div>
            <div v-show="getDirectoryName==='院校概况'" class="main">
              <div class="item introduction">
                <div style="min-height: 125px;" class="position-relative">
                  <div class="con" v-show="univerSityDetail!==''&&!loadingDetail">
                    <div class="info">
                      <h4 class="tit">{{ univerSityDetail.name }}简介</h4>
                      <p>
                        <span>学生人数：<em>{{ univerSityDetail.studentNum }}人</em></span>
                        <span>院士人数：<em>{{ univerSityDetail.academicianNum }}</em></span>
                        <span>硕士点个数：<em>{{ univerSityDetail.masterNum }}</em></span>
                        <span>博士点个数：<em>{{ univerSityDetail.doctorNum }}</em></span>
                        <br>
                        <span>院校地址：{{ univerSityDetail.address }}</span>
                      </p>
                    </div>
                    <div class="website">
                      <el-button size="mini" type="primary">
                        <a :href="univerSityDetail.webSite" class="text-white" target="_blank"> 官方网站</a>
                      </el-button>
                      <el-button size="mini" type="primary">
                        <a :href="univerSityDetail.enWebsite" class="text-white" target="_blank">
                          招生网址
                        </a>
                      </el-button>
                    </div>
                  </div>
                  <empty v-show="univerSityDetail===''&&!loadingDetail" content="暂无院校详情" :text-size="18" :widths="100"
                         :heights="100"></empty>
                  <loading v-show="loadingDetail" width="1025px"></loading>
                </div>
                <div class="intro">
                  <div class="inner position-relative">
                    <div v-show="briefIntroduction!==''&&!loadingIntro" v-html="briefIntroduction"></div>
                    <empty v-show="briefIntroduction===''&&!loadingIntro" content="暂无院校简介" :text-size="18" :widths="150"
                           :heights="150"></empty>
                    <loading v-show="loadingIntro" width="1025px"></loading>
                  </div>
                  <a v-show="briefIntroduction!==''&&!univerSityShowHidden" @click="controllUniverContent('show')"
                     href="javascript:;" class="more">展开全部<i class="el-icon-arrow-down"></i></a>
                  <a v-show="briefIntroduction!==''&&univerSityShowHidden" @click="controllUniverContent"
                     href="javascript:;" class="more">收起<i class="el-icon-arrow-down"></i></a>
                </div>
              </div>
              <div class="item"><h4 class="tit">{{ univerSityDetail.name }}特色专业</h4>
                <div class="con position-relative">
                  <div v-show="getUniSpecialty!==''&&!loadingSpecialty" v-html="getUniSpecialty">
                  </div>
                  <empty v-show="getUniSpecialty===''&&!loadingSpecialty" content="暂无院校特色" :text-size="18" :widths="150"
                         :heights="150">
                  </empty>
                  <loading v-show="loadingSpecialty" width="1025px"></loading>
                </div>
              </div>
              <div class="item">
                <h4 class="tit">{{ univerSityDetail.name }}院系设置</h4>
                <div class="con position-relative">
                  <div v-show="departMentContent!==''&&!loadingDepartment" v-html="departMentContent">
                  </div>
                  <empty v-show="departMentContent===''&&!loadingDepartment" content="暂无院系设置" :text-size="18"
                         :widths="150" :heights="150">
                  </empty>
                  <loading v-show="loadingDepartment" width="1025px"></loading>
                </div>
              </div>
            </div>
            <college-publicity-video v-show="getDirectoryName==='名校展播'"
                                     :univerSityId="univerSityId"></college-publicity-video>
            <enrollment-regulations v-show="getDirectoryName==='招生章程'"
                                    :univerSityId="univerSityId"></enrollment-regulations>
            <all-panorama-picture v-show="getDirectoryName==='全景校园'"
                                  :univerSityId="univerSityId"></all-panorama-picture>
            <employment-related-data v-show="getDirectoryName==='就业走向'"
                                     :univerSityId="univerSityId"></employment-related-data>


            <div v-show="getDirectoryName==='招生计划'">
              <div class="item introduction">
              <el-table
                  :header-cell-style="{background:'#f5f6f7',color:'#333',border: '1px solid #E7EBF0'}"
                  :data="enrollPlanData"
                  style="width: 1200px"
                  border >
                <el-table-column
                    prop="Batch"
                    align="center"
                    label="层次"
                    width="100">
                </el-table-column>
                <el-table-column
                    prop="MajorName"
                    label="专业名称">
                </el-table-column>

                <el-table-column
                    prop="Plan"
                    label="计划数"
                    align="center"
                    width="100">
                </el-table-column>

                <!--6选3的选科-->
                <el-table-column
                    prop="SubjectRequire"
                    label="选科要求"
                    align="center"
                    width="150">
                </el-table-column>
                <!--6选3的选科-->

                <el-table-column
                    prop="fee"
                    label="学费"
                    width="120">
                  <template slot-scope="scope">
                    {{ scope.row.Fee }}
                  </template>
                </el-table-column>

              </el-table>

              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  favUniver,
  uniDepartment,
  uniDetail,
  uniEnrollPlan,
  uniProfile, uniScoreYeas,
  uniSpecialty,
  uniUnFav
} from "../../../../config";
import collegePublicityVideo from './components/collegePublicityVideo';
import enrollmentRegulations from './components/enrollmentRegulations';
import allPanoramaPicture from './components/allPanoramaPicture';
import employmentRelatedData from './components/employmentRelatedData';
import {EventBus} from "../../../../assets/static/global/event-bus";

export default {
  name: "collegeDetail",
  components: {
    employmentRelatedData,
    collegePublicityVideo,
    enrollmentRegulations,
    allPanoramaPicture
  },
  data() {
    return {
      selectedScoreYear:'',
      enrollPlanData:[],
      scoreYears: [],
      pageIndex: 1,
      totalPages: 1,
      totalRecords: 1,
      gudFlag: false,
      loadingDetail: false,
      loadingIntro: false,
      univerSityFeature: [],
      //左侧目录列表
      getLeftDirectoryList: [
        {id: 1, name: '院校概况'},
        {id: 2, name: '名校展播'},
        {id: 4, name: '就业走向'},
        {id: 5, name: '招生章程'},
        {id: 6, name: '招生计划'},
      ],
      //获取所选择目录的id
      getDirectoryName: '院校概况',
      //获取院校id
      univerSityId: '',
      univerSityName: '',
      //根据id查出大学详情
      univerSityDetail: "",
      //获取大学简介
      briefIntroduction: '',
      //获取院校特色
      getUniSpecialty: '',
      loadingSpecialty: false,
      //院校简介展开收起控制
      univerSityShowHidden: false,
      //院系设置内容
      departMentContent: '',
      loadingDepartment: false,
      //获取当前院校是否收藏
      getUniverSityFav: 0
    }
  },
  mounted() {
    this.univerSityId = this.$route.query.univerSityId;
    this.searchDetail();
    this.uniProfileIntro();
    this.searchUniverSitySpecialty();
    this.getUniversitySetting();
    this.collegeEnrollPlan()
    this.getSoreYears()

    window.onscroll = (() => {

      if (window.pageYOffset >= 274) {
        this.gudFlag = true;
      } else {
        this.gudFlag = false;
      }
    })
  },
  beforeRouteLeave(to, from, next) {
    window.onscroll = (() => {

    });
    next();
  },
  methods: {
    //招生计划
    async collegeEnrollPlan(){
      let result = await uniEnrollPlan(this.univerSityId);
      if (result.status) {
         this.enrollPlanData=result.data
      }
    },

    //获取分数数据年份
    async getSoreYears() {
      let res = await uniScoreYeas(this.univerSityId)
      if (res.data.status) {
        this.scoreYears = res.data.data
        if (res.data.data.length > 0) {
          this.selectedScoreYear = res.data.data[0]
        }
      }
    },

    //获取历年分数数据
    async getYearScore() {
      let res = await getYearScore({
        year: this.selectedScoreYear,
        schoolId: Number(this.collegeId),
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      })

      if (res.data.status) {
        this.scoreData = res.data.data.data
        this.scoreDataTotal = res.data.data.totalRecords
      }
    },


    //切换下拉菜单
    changeSelecteScoreYear() {
      this.getYearScore()
    },



    //收藏大学
    async collectionContent() {
      let result = await favUniver(this.univerSityId);
      if (result.status) {
        this.getUniverSityFav = 1;
      }
    },
    //取消收藏大学
    async cancelCollection() {
      let result = await uniUnFav(this.univerSityId);
      if (result.status) {
        this.getUniverSityFav = 0;
      } else {

      }
    },

    //获取大学院校设置
    async getUniversitySetting() {
      this.loadingDepartment = true;
      let result = await uniDepartment(this.univerSityId);
      if (result.status) {
        this.departMentContent = result.data;
        this.loadingDepartment = false;
      } else {
        this.loadingDepartment = false;
      }
    },
    //控制院校内容
    controllUniverContent(val) {
      if (val === 'show') {
        this.univerSityShowHidden = true;
        document.querySelector('.inner').style.height = "auto";
      } else {
        this.univerSityShowHidden = false;
        document.querySelector('.inner').style.height = "256px";
      }
    },
    //选择左侧目录
    selectDirectory(val) {
      this.getDirectoryName = val;
      if (val === '名校展播') {
        EventBus.$emit('publicityVideo');
      } else if (val === '招生章程') {
        this.commonDelVideo();
        EventBus.$emit('collegeZsjz');
      } else if (val === '全景校园') {
        this.commonDelVideo();
        EventBus.$emit('qjSchool');
      } else if (val === '就业走向') {
        this.commonDelVideo();
        EventBus.$emit('jyZx')
      } else if (val === '招生计划') {
        this.commonDelVideo();
        EventBus.$emit('zsjh')
      } else if (val === '录取数据') {
        this.commonDelVideo();
        EventBus.$emit('lqsj')
      }
    },
    commonDelVideo() {
      EventBus.$emit('publicityVideo', {type: 'delVideo'});
    },
    //查出院校特色
    async searchUniverSitySpecialty() {
      this.loadingSpecialty = true;
      let result = await uniSpecialty(this.univerSityId);
      if (result.status) {
        this.getUniSpecialty = result.data;
        this.loadingSpecialty = false;
      } else {
        this.loadingSpecialty = false;

      }
    },
    //查出大学简介
    async uniProfileIntro() {
      this.loadingIntro = true;
      let result = await uniProfile(this.univerSityId);
      if (result.status) {
        this.loadingIntro = false;
        this.briefIntroduction = result.data;
      } else {
        this.loadingIntro = false;
      }
    },
    //查出院校详情
    async searchDetail() {
      this.univerSityDetail = "";
      this.loadingDetail = true;
      let result = await uniDetail(this.univerSityId);
      if (result.status) {
        this.getUniverSityFav = result.data.hasFaved;
        this.loadingDetail = false;
        this.univerSityDetail = result.data;
        this.univerSityName = result.data.name;
        this.univerSityFeature = result.data.feature.split(",")
      } else {
        this.loadingDetail = false;
      }
    },
    search() {

    }
  }
}
</script>
<style>
.overview .main .item table td, .overview .main .item table th {
  color: #666666;
  padding: 10px 5px !important;
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  text-align: center;
  border: 1px solid #222;
}

table {
  border-collapse: collapse !important;
  border-spacing: 0 !important;
}
</style>
<style lang="scss" scoped>
#collegeDetail {
  margin-top: 60px;

  .tab.gud {
    position: fixed;
    top: 70px;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  .g-wrapper {
    width: 1200px;
    margin: 0 auto;

  }

  .college_tab {
    padding-top: 40px;

    .g-wrapper {
      .content.gud {
        margin-left: 140px;
      }

      .content {
        /*margin-left: 140px;*/
        .overview {
          .title {
            padding: 6px 0 6px 30px;
            font-size: 18px;

            font-weight: 400;

            background: #0060FF;
            color: #ffffff;
          }

          .main {
            .con {
              min-height: 190px;
            }

            padding: 0 30px 30px;

            .item {
              margin: 20px 0 30px;
              line-height: 28px;

              .tit {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                margin-bottom: 10px;
                font-size: 16px;
              }

              .tit:before {
                content: "";
                display: inline-block;
                width: 6px;
                height: 16px;
                margin-right: 10px;
                background: #f70;
                border-radius: 5px;
              }

              h3 {
                color: #333;
                padding-bottom: 5px !important;
              }

              table {
                width: 100%;
                margin: 20px 0 !important;
              }


            }

            .item.introduction {
              .con {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-wrap: wrap;
                flex-wrap: wrap;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;
                -webkit-box-align: center;
                -ms-flex-align: center;
                align-items: center;
                padding-bottom: 10px;
                border-bottom: 1px solid #e4e7ed;

                .info {
                  p {
                    padding-left: 16px;

                    span {
                      display: inline-block;
                      margin-right: 20px;
                      line-height: 28px;

                      em {
                        color: #f70;
                        font-weight: 700;
                      }
                    }
                  }
                }

              }

              .intro {
                line-height: 32px;
                padding-top: 10px;

                .inner {
                  height: 256px;
                  overflow: hidden;
                }

                .more {
                  float: right;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
